<!--
 * @Author: L
 * @Date: 2022-03-25 15:41:18
 * @LastEditTime: 2024-02-29 16:42:34
-->
<template>
  <div>
    <div style="margin: 30px 0 10px;">
      <el-upload
        ref="upload"
        action=""
        :auto-upload="false"
        :before-upload="beforeVideoUpload"
        :on-change="onChange"
        accept="video/*"
        :show-file-list="true"
      >
        <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="uploadToAli">上传</el-button>
      </el-upload>

    </div>
  </div>
</template>

<script>

const OSS = require('ali-oss')
export default {
  data() {
    return {
      currentFile: null,
      ossClient: null
    }
  },
  created() {
    this.ossClient = OSS({
      secure: true,
      region: 'oss-cn-beijing',
      accessKeyId: 'LTAIxpz3rsDmzgCX',
      accessKeySecret: window.atob('MTc3Z3lPbUNuTm9UWlo1a2lNeVU4VnZNemNJSzg2'),
      bucket: 'adksstatic'
    })
  },
  methods: {
    async uploadToAli() {
      if (this.currentFile) {
        console.log(this.currentFile.raw)
        console.log(this.ossClient)
        try {
          const result = await this.ossClient.put('/website/liushuiping/' + new Date().getTime() + '.mp4', this.currentFile.raw)
          console.log(result)
        } catch (e) {
          console.log(e)
        }
      }
    },
    onChange(file, fileList) {
      this.currentFile = file
    },
    beforeVideoUpload(file) {
      console.log('--------------------------')
      //  const isVideo =
      //   file.type === "image/jpg" ||
      //   file.type === "image/jpeg" ||
      //   file.type === "image/gif" ||
      //   file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 2048

      // if (!isVideo) {
      //   this.$message.error("上传视频格式不正确!");
      // }
      if (!isLt5M) {
        this.$message.error('上传视频大小不能超过 2GB!')
      }
      return isLt5M
    },
    onChange(file, fileList) {
      this.currentFile = file
    }
  }
}
</script>

<style>

</style>
